module.exports = __webpack_public_path__ + "Frame409-301f77af.webp";